export default __webpack_public_path__ + "static/media/Group20.bc71509f.png";